(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emporo-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    function setup(row) {
      if (row.eIndex) return;
      var track = row.querySelector('[data-e-index-track]');
      if (!track) return;
      var st = { period: 0, speed: 0, offset: 0, raf: 0, last: 0, hover: false, focus: false, drag: null, vx: 0, idleUntil: 0, onScreen: true, suppress: false, lastW: 0 };
      row.eIndex = st;
      var seconds = parseFloat(row.getAttribute('data-e-index')) || 60;

      function originals() {
        return Array.prototype.filter.call(track.children, function (c) { return !c.hasAttribute('data-e-index-clone'); });
      }
      function paint() { track.style.transform = 'translate3d(' + (-st.offset).toFixed(2) + 'px,0,0)'; }
      function wrap() {
        if (!st.period) return;
        st.offset = st.offset % st.period;
        if (st.offset < 0) st.offset += st.period;
      }
      function active() {
        return st.period > 0 && st.onScreen && !document.hidden && !reduced.matches && row.isConnected;
      }

      function layout() {
        track.querySelectorAll('[data-e-index-clone]').forEach(function (n) { n.remove(); });
        row.classList.remove('is-ready');
        track.style.transform = '';
        st.period = 0;
        st.lastW = row.clientWidth;
        if (reduced.matches) return;
        var items = originals();
        if (items.length < 2) return;
        var w0 = track.getBoundingClientRect().width;
        if (!w0) return;
        items.forEach(function (it) {
          var c = it.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('data-e-index-clone', '');
          c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
          c.querySelectorAll('a, button, [tabindex]').forEach(function (f) { f.setAttribute('tabindex', '-1'); });
          track.appendChild(c);
        });
        // One copy plus the gap between the copies: the seamless period.
        st.period = track.getBoundingClientRect().width - w0;
        if (st.period <= 0) { st.period = 0; return; }
        st.speed = st.period / seconds;          // px per second
        wrap();
        paint();
        row.classList.add('is-ready');
        run();
      }

      function tick(now) {
        st.raf = 0;
        if (!active()) { st.last = 0; return; }
        var dt = st.last ? Math.min(64, now - st.last) : 0;
        st.last = now;
        if (st.drag) {
          // the pointer owns the offset
        } else if (st.vx && !st.focus) {
          st.offset += st.vx * dt;
          st.vx *= Math.pow(0.95, dt / 16);
          if (Math.abs(st.vx) < 0.01) { st.vx = 0; st.idleUntil = now + 1200; }
          wrap();
          paint();
        } else if (!st.hover && !st.focus && now >= st.idleUntil) {
          st.offset += st.speed * dt / 1000;
          wrap();
          paint();
        }
        st.raf = requestAnimationFrame(tick);
      }
      function run() {
        if (!st.raf && active()) { st.last = 0; st.raf = requestAnimationFrame(tick); }
      }

      /* pause: a pointer that can hover; keyboard focus inside the row */
      row.addEventListener('pointerenter', function (e) {
        if (fine.matches && e.pointerType !== 'touch') st.hover = true;
      });
      row.addEventListener('pointerleave', function () { st.hover = false; });
      row.addEventListener('focusin', function (e) {
        st.focus = true;
        st.vx = 0;                                            // a fling never carries a focused card away
        if (!st.period || !e.target.closest) return;
        var card = e.target.closest('[data-e-index-card]');
        if (!card) return;
        var cb = card.getBoundingClientRect();
        var rb = row.getBoundingClientRect();
        if (cb.left < rb.left || cb.right > rb.right) {
          // Track-relative, not viewport-relative: offsetLeft ignores the
          // transform, so the target offset is exact whatever the track's
          // current position, and it cannot land on the wrap seam.
          var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
          st.offset = card.offsetLeft - pad;
          wrap();
          paint();
        }
      });
      row.addEventListener('focusout', function () { st.focus = false; });

      /* drag: pointer and touch; a vertical swipe is left to the page */
      row.addEventListener('pointerdown', function (e) {
        if (!st.period) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        st.vx = 0;
        st.drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, o0: st.offset, moved: false, lx: e.clientX, lt: e.timeStamp, v: 0 };
      });
      row.addEventListener('pointermove', function (e) {
        var d = st.drag;
        if (!d || e.pointerId !== d.id) return;
        var dx = e.clientX - d.x0;
        var dy = e.clientY - d.y0;
        if (!d.moved) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { st.drag = null; return; }
          d.moved = true;
          row.classList.add('is-dragging');
          try { row.setPointerCapture(d.id); } catch (err) { /* unsupported */ }
        }
        var dt = e.timeStamp - d.lt;
        if (dt > 0) d.v = -(e.clientX - d.lx) / dt;          // px per ms, along the drift
        d.lx = e.clientX;
        d.lt = e.timeStamp;
        st.offset = d.o0 - dx;
        wrap();
        paint();
        e.preventDefault();
      });
      function release(e) {
        var d = st.drag;
        if (!d) return;
        if (e && typeof e.pointerId === 'number' && e.pointerId !== d.id) return;
        st.drag = null;
        row.classList.remove('is-dragging');
        if (d.moved) {
          st.vx = Math.max(-2.5, Math.min(2.5, d.v));
          st.idleUntil = performance.now() + 1500;
          st.suppress = true;                                 // the click that ends a drag is not a click
          setTimeout(function () { st.suppress = false; }, 50);
        }
        run();
      }
      row.addEventListener('pointerup', release);
      row.addEventListener('pointercancel', release);
      row.addEventListener('click', function (e) {
        if (st.suppress) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* only move while looked at */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { st.onScreen = en.isIntersecting; });
          run();
        }, { rootMargin: '10% 0px 10% 0px', threshold: 0 }).observe(row);
      }
      document.addEventListener('visibilitychange', run);

      var pending = null;
      function relayout() {
        if (pending) clearTimeout(pending);
        pending = setTimeout(function () { pending = null; layout(); }, 80);
      }
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { if (row.clientWidth !== st.lastW) relayout(); }).observe(row);
      } else {
        window.addEventListener('resize', relayout);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout).catch(function () {});
      if (reduced.addEventListener) reduced.addEventListener('change', relayout);

      layout();
    }

    function scan() { document.querySelectorAll('[data-e-index]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emporo-inside"]) return;
  try {
    
  (function () {
    'use strict';
    var wide = window.matchMedia('(min-width: 750px)');
    function openAll(tree) {
      if (tree.getAttribute('data-e-open') === 'false') return;
      tree.querySelectorAll('[data-e-inside-folder]').forEach(function (d) { d.open = true; });
      tree.classList.add('is-open');
    }
    function wire(section) {
      if (section.eInside) return;
      section.eInside = true;
      var tree = section.querySelector('.e-inside__tree');
      var btn = section.querySelector('[data-e-inside-all]');
      if (!tree) return;
      if (wide.matches) openAll(tree);
      if (btn) {
        btn.addEventListener('click', function () {
          openAll(tree);
          btn.setAttribute('aria-expanded', 'true');
        });
      }
      if (wide.addEventListener) wide.addEventListener('change', function () { if (wide.matches) openAll(tree); });
    }
    function scan() { document.querySelectorAll('.e-inside').forEach(wire); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emporo-lookinside"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function headerHeight() {
    var header = document.querySelector('[data-e-header]');
    if (header && header.offsetHeight) return header.offsetHeight;
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--e-header-h'));
    return isFinite(v) && v > 0 ? v : 64;
  }

  // Delegated from document: a re-rendered section needs no re-binding.
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-e-lookinside-index]') : null;
    if (!btn) return;
    var gallery = document.querySelector('[data-e-gallery]');
    if (!gallery) return;
    event.preventDefault();

    var index = btn.getAttribute('data-e-lookinside-index');
    var scope = gallery.closest('[data-e-product]') || document;
    var thumb = scope.querySelector('[data-e-thumb][data-e-index="' + index + '"]');
    // The thumbnail owns "show slide N" (emporo-product); a hidden thumbnail
    // still takes a programmatic click.
    if (thumb) thumb.click();

    // Whichever element scrolls (the window, or Horizon's .page-wrapper from
    // 990px), scrollIntoView reaches it; the inline scroll margin keeps the
    // gallery clear of the sticky header.
    gallery.style.scrollMarginTop = (headerHeight() + 16) + 'px';
    try {
      gallery.scrollIntoView({ block: 'start', behavior: reduced.matches ? 'auto' : 'smooth' });
    } catch (e) {
      gallery.scrollIntoView(true);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emporo-product"]) return;
  try {
    
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 749.98px)');
  var rail = window.matchMedia('(min-width: 1440px)');

  function headerHeight() {
    var header = document.querySelector('[data-e-header]');
    if (header && header.offsetHeight) return header.offsetHeight;
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--e-header-h'));
    return isFinite(v) && v > 0 ? v : 64;
  }

  // Thumbnails pick the slide. From 750px the CSS shows only .is-active; under
  // it the slides are a scroll-snap carousel, so a pick scrolls to the slide.
  function gallery(root) {
    var slides = root.querySelectorAll('[data-e-slide]');
    var thumbs = root.querySelectorAll('[data-e-thumb]');
    if (slides.length < 2 || !thumbs.length) return;

    function show(index, focus) {
      if (index < 0 || index >= slides.length) return;
      Array.prototype.forEach.call(slides, function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      Array.prototype.forEach.call(thumbs, function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && focus) thumb.focus();
      });
      if (phone.matches && slides[index].scrollIntoView) {
        slides[index].scrollIntoView({
          block: 'nearest',
          inline: 'start',
          behavior: reduced.matches ? 'auto' : 'smooth'
        });
      }
    }

    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      thumb.addEventListener('click', function () { show(i, false); });
      thumb.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = slides.length - 1;
        if (next === null) return;
        event.preventDefault();
        show((next + slides.length) % slides.length, true);
      });
    });
  }

  // Scroll events do not bubble; listening in the capture phase on the
  // document sees the window and Horizon's .page-wrapper (the scroller from
  // 990px) alike. One rect read per frame while scrolling, none at rest.
  function onScrollFrame(fn) {
    var ticking = false;
    function tick() { ticking = false; fn(); }
    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(tick);
    }
    document.addEventListener('scroll', request, true);
    window.addEventListener('resize', request);
    fn();
  }

  // The bar is a sibling of the band (both sit in the section wrapper), so
  // it is looked up from the wrapper, not from inside the band. It shows
  // only once the real button has scrolled up past the viewport top — never
  // while the button is still below the fold and about to appear. A scroll
  // check rather than an IntersectionObserver: a jump (an anchor, a deep
  // link) can carry the button from below the fold to above it without ever
  // crossing the viewport, and an observer would never fire.
  function stickyBar(root) {
    var scope = root.parentNode || document;
    var bar = scope.querySelector('[data-e-bar]');
    var anchor = root.querySelector('[data-e-buy-anchor]');
    if (!bar || !anchor) return;

    onScrollFrame(function () {
      var past = phone.matches && anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('e-product-bar-on', past);
    });
  }

  // After a notify post the page reloads at #<form id>; put the result line
  // where a screen reader and a thumb both find it.
  function notify(root) {
    var msg = root.querySelector('.e-product__notify-msg');
    if (!msg || !window.location.hash) return;
    var form = root.querySelector('.e-product__notify');
    if (!form || '#' + form.id !== window.location.hash) return;
    try { msg.focus({ preventScroll: false }); } catch (e) { /* older engines */ }
  }

  // The index. Its links are aimed in Liquid at the sibling section wrappers
  // (#shopify-section-<template>__<key>); here a link whose section is not
  // on the page, or renders nothing (reviews with no real review, a section
  // not yet built), is dropped so the index never points at an empty spot.
  // The in-view highlight is emporo.js's job ([data-e-toc]); without it this
  // is a plain list of working links. On the desktop rail the index fades
  // once the page's last section has scrolled up past it, so it never hangs
  // over the footer.
  function toc(root) {
    var scope = root.parentNode || document;
    var nav = scope.querySelector('[data-e-toc-nav]');
    if (!nav) return;

    var links = nav.querySelectorAll('[data-e-toc-target]');
    var alive = 0;
    Array.prototype.forEach.call(links, function (link) {
      var id = link.getAttribute('data-e-toc-target');
      var target = id ? document.getElementById(id) : null;
      var item = link.closest('li') || link;
      var dead = !target || target.offsetHeight < 2;
      item.hidden = dead;
      if (!dead) alive += 1;
    });
    nav.hidden = alive === 0;
    if (nav.hidden) return;

    // The in-view highlight, and keeping the current chip in view on the
    // phone row, are emporo.js's ([data-e-toc]: aria-current="true" and
    // .is-current on the link). Nothing here touches either.

    if (!nav.hasAttribute('data-e-toc-stick')) return;
    var main = document.getElementById('MainContent') || nav.parentNode;
    var last = main ? main.querySelector(':scope > .shopify-section:last-child') : null;
    if (!last || last === nav.parentNode) return;
    var inner = nav.querySelector('.e-toc__inner');
    if (!inner) return;

    onScrollFrame(function () {
      if (!rail.matches) { nav.classList.remove('is-past'); return; }
      var railBottom = headerHeight() + 24 + inner.offsetHeight;
      nav.classList.toggle('is-past', last.getBoundingClientRect().bottom < railBottom);
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-e-product]');
    Array.prototype.forEach.call(sections, function (root) {
      if (root.getAttribute('data-e-ready') === '1') return;
      root.setAttribute('data-e-ready', '1');
      try { gallery(root); } catch (e) { console.warn('[emporo-product] gallery failed', e); }
      try { stickyBar(root); } catch (e) { console.warn('[emporo-product] sticky bar failed', e); }
      try { notify(root); } catch (e) { console.warn('[emporo-product] notify failed', e); }
      try { toc(root); } catch (e) { console.warn('[emporo-product] index failed', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
